export interface Message {
  jobId: string;
  chatId: string;
  content: string;
  recipientId: string;
  senderId: string;
  createdAt: string;
}

interface Room {
  _id: string;
  jobId: string;
  jobTitle: string;
  lastActivityAt: string;
  lastMessage: {
    content: string;
    senderId: string;
    createdAt: string;
  };
  // ... other fields
}

interface GroupedRoom {
  _id: string;
  lastActivityAt: string;
  recentRooms: Room[];
  // ... other fields
}

/**
 * Updates a specific group and room based on a new socket message
 * and sorts the entire structure by most recent activity.
 */
export const updateAndSortChatGroups = (
  groups: GroupedRoom[],
  incomingMessage: Message
): GroupedRoom[] => {
  console.log('this is incoming message',incomingMessage)
  const { jobId, createdAt, content, senderId } = incomingMessage;
  const groupIndex = groups?.findIndex((group) => group.recentRooms.some((r) => r.jobId === jobId));

  if (groupIndex !== 1) {
    const updatedGroups = groups.map((group) => {
      // 1. Check if the job/room exists in this group
      const roomIndex = group.recentRooms.findIndex((r) => r.jobId === jobId);

      if (roomIndex !== -1) {
        const updatedRooms = [...group.recentRooms];

        // 2. Update the specific room's metadata
        updatedRooms[roomIndex] = {
          ...updatedRooms[roomIndex],
          lastActivityAt: createdAt,
          lastMessage: {
            content,
            senderId,
            createdAt,
          },
        };

        // 3. Sort rooms within the group (Latest first)
        updatedRooms.sort(
          (a, b) => new Date(b.lastActivityAt).getTime() - new Date(a.lastActivityAt).getTime()
        );

        return {
          ...group,
          recentRooms: updatedRooms,
          lastActivityAt: createdAt, // Update group's overall timestamp
        };
      }
      return group;
    });

    // 4. Sort the groups themselves so the one with the newest message is at the top
    return updatedGroups.sort(
      (a, b) => new Date(b.lastActivityAt).getTime() - new Date(a.lastActivityAt).getTime()
    );
  }else{
    return []
  }
  
};